import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  jcSE: {
    justifyContent: 'space-evenly',
  },
  cardStyle: {
    cursor: 'pointer',
    backgroundColor: '#FFF8F8',
    border: '1px solid black',
    width: '100%',
    height: '100%',
    '&:hover': {
      backgroundColor: '#FFD7D7',
    },
  },
  cardSelected: {
    cursor: 'pointer',
    backgroundColor: '#FFD7D7',
    border: '1px solid black',
    width: '100%',
    height: '100%',
  },
  G1: {
    width: '100%',
    height: '100%',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  G2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: "8px",
  },
  G3: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContent: {
    height: 'inherit',
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  count: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: '2.5rem',
  },
  title: {
    textAlign: 'center',
    fontSize: '0.75rem',
    fontWeight: 500,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    lineHeight: 1.2,
    padding: '2px',
  },
}));

